module.exports = __webpack_public_path__ + "img/home-header-logos.612fee9f.svg";